import { Typography, Box } from "@mui/material";

const Dashboard = () => {
  return (
    <Box>
      <Typography variant="h4">Welcome to the Smart HR Admin Panel</Typography>
      <Typography variant="body1" sx={{ marginTop: 2 }}>
        Use the sidebar to manage companies and users.
      </Typography>
    </Box>
  );
};

export default Dashboard;
